<template>
	<!-- url 编码 -->
    <el-container>
		<div class="edit-text">
			<editor v-model="textarea2"
			    @init="editorInit"
			    :options="{}"
			    lang="text"
				:theme="editorTheme"
			    width="100%"
			    height="100%">
			</editor>
		</div>
        <div style="margin: 15px 0px;">
            <el-button-group>
                <el-button type="primary" @click="encodeAction">UrlEncode编码</el-button>
				<el-button type="primary" @click="decodeAction">UrlDecode解码</el-button>
            </el-button-group>
			<el-button-group>
			    <el-button type="primary" @click="encodeComponentAction">encodeURIComponent编码</el-button>
				<el-button type="primary" @click="decodeComponentAction">decodeURIComponent解码</el-button>
			</el-button-group>
        </div>
		<div class="edit-text">
			<editor v-model="resultText"
			    @init="editorInit"
			    :options="{wrap: true, readOnly: false,}"
			    lang="text"
				:theme="editorTheme"
			    width="100%"
			    height="100%">
			</editor>
		</div>
    </el-container>
</template>

<script>
export default {
    name: "g-urlEnToDe",
    data() {
        return {
            textarea2:"",
			resultText:'',
        };
    },
	components: {
		editor: require('vue2-ace-editor'),
	},
    methods: {
        encodeAction(){
            this.resultText = encodeURI(this.textarea2);
        },
		decodeAction(){
			this.resultText = decodeURI(this.textarea2);
		},
		encodeComponentAction(){
		    this.resultText = encodeURIComponent(this.textarea2);
		},
		decodeComponentAction(){
			this.resultText = decodeURIComponent(this.textarea2);
		}
	},
    mounted() {
        
    },
};
</script>
<style lang="scss" scoped>
	.el-container /deep/{
		flex-flow: column;
		display: flex;
		
		.edit-text{
			flex: 1;
			display: flex;
			border: 1px solid #DCDFE6;
			border-radius: 3px;
			overflow: hidden;
		}
	}
</style>
